import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowDownRightComponent } from "./med-icon-arrow-down-right.component";

@NgModule({
  declarations: [
    MedIconArrowDownRightComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowDownRightComponent,
  ],
})
export class MedIconArrowDownRightModule { }
